import { lazy } from 'react';

export const LazyMoarPage = lazy(
  () =>
    import(/* webpackChunkName: "hellospa--page--moar-page" */ './moar-page'),
);
